import { Observable } from 'rxjs';
import { IAttachment } from '@valhalla/data/entities';

export abstract class FileDataHttpService {
	abstract mapFileToAttachment(file: File): Partial<IAttachment>;
	/** load to TEMP table */
	abstract preUploadFile(params: IAttachUploadParams): IAttachUploadResult;
	/** load to MAIN table */
	abstract uploadFile(params: IAttachUploadParams): IAttachUploadResult;

	abstract openFileDialog(options?: Partial<IFileDialogOptions>): Observable<IFileDialogResult>;

	abstract ToPreUploadedFiles(formData: FormData): Observable<IPreuploadedFilesResponse>;
}

export interface IAttachUploadParams {
	taskId?: number | string;
	attach: Partial<IAttachment>;
	cancel$?: Observable<any>;
}

export interface IUploadResult<T = any> {
	progressPercent$: Observable<number>;
	result$: Observable<T>;
	cancel: () => void;
}

export interface IAttachUploadResult extends IUploadResult<Partial<IAttachment>> {}

export interface IFileDialogOptions {
	multiple: boolean;
}

export interface IFileDialogResult {
	files: File[];
}

export interface IPreuploadedFilesElem {
	fileId: number;
	fileName: string;
	fileVersion: number;
	preUploadFileId: number;
}

export interface IPreuploadedFilesResponse {
	data: IPreuploadedFilesElem[];
}
